function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { useEffect, useState, useMemo, useDebugValue } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { WDHComponent } from '../../../../../wdh-foundation/wdh';
import SboPrintShippingLabel from './sbo-print-shipping-label';
import SboAddressInfo from './sbo-address-info';
import SboPackageContent from './sbo-package-content';
import SboPackageOptions from './sbo-package-options';
import SboPrintModalDialog from './sbo-print-modal-dialog';
import SboPrintHazMatLabel from './sbo-print-hazmat-label';
var WDHSboPrintShippingLabelSpot = /*#__PURE__*/function (_WDHComponent) {
  function WDHSboPrintShippingLabelSpot() {
    var classname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'print-shipping-label';
    _classCallCheck(this, WDHSboPrintShippingLabelSpot);
    return _callSuper(this, WDHSboPrintShippingLabelSpot, [classname]);
  }
  _inherits(WDHSboPrintShippingLabelSpot, _WDHComponent);
  return _createClass(WDHSboPrintShippingLabelSpot, [{
    key: "init",
    value: function init(component) {
      var getConfig = function getConfig() {
        var script = document.querySelector('script[type="application/json"]');
        var config = JSON.parse(script.innerHTML);
        var endpoint = config.endpoint;
        return endpoint;
      };
      ReactDOM.render(/*#__PURE__*/React.createElement(SboPrintShippingLabelSpot, {
        config: getConfig(),
        className: this.className
      }), component.querySelector('.component-content'));
    }
  }]);
}(WDHComponent);
export default WDHSboPrintShippingLabelSpot;
var SboPrintShippingLabelSpot = function SboPrintShippingLabelSpot(config) {
  var _labelRefText$, _labelRefText$2;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPrintShippingLabelModal = _useState2[0],
    setShowPrintShippingLabelModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPrintHazardLabelModal = _useState4[0],
    setShowPrintHazardLabelModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showErrors = _useState6[0],
    setShowErrors = _useState6[1];
  var _useState7 = useState(new Set()),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedContents = _useState8[0],
    setSelectedContents = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isRush = _useState0[0],
    setIsRush = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    hasLithium = _useState10[0],
    setHasLithium = _useState10[1];
  var _useState11 = useState(new Set()),
    _useState12 = _slicedToArray(_useState11, 2),
    validations = _useState12[0],
    setValidations = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    labelRefText = _useState14[0],
    setLabelRefText = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    data = _useState16[0],
    setData = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    loading = _useState18[0],
    setLoading = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    error = _useState20[0],
    setError = _useState20[1];
  var customerId = window.sessionStorage.getItem('cid');
  var shippingEndpoint = "".concat(config.config, "api/customers/").concat(customerId, "/shipping-addresses");
  useDebugValue("labelRefText = ".concat(labelRefText));
  var contentTypes = {
    newItem: {
      text: 'New item order',
      labelText: 'New item order',
      allowSerialNumbers: false
    },
    impression: {
      text: 'Impression for mold order',
      labelText: 'Mold impression',
      allowSerialNumbers: false
    },
    repairRemake: {
      text: 'Repair/remake',
      labelText: 'Repair/remake',
      allowSerialNumbers: true
    },
    returnExchange: {
      text: 'Return for exchange or credit*',
      labelText: 'Return/exchange',
      allowSerialNumbers: true
    },
    other: {
      text: 'Other',
      labelText: '',
      allowSerialNumbers: false
    }
  };
  var _handleValidationChange = function handleValidationChange(validation) {
    if (!validation.value) {
      validations.add(validation.key);
    }
    if (validation.value && validations.has(validation.key)) {
      validations.delete(validation.key);
    }
    setValidations(validations);
  };
  useEffect(function () {
    var i = 0;
    var lines = ['', ''];
    var deferred = [];
    selectedContents.forEach(function (value) {
      if (value.allowSerialNumbers) {
        deferred.push(value);
      } else {
        var divider = lines[i % 2].length === 0 ? '' : '|';
        lines[i % 2] += "".concat(divider).concat(value.labelText);
      }
      i += 1;
    });
    if (isRush) {
      var divider = lines[1].length === 0 ? '' : '|';
      lines[1] = "Rush".concat(divider).concat(lines[1]);
    }
    deferred.forEach(function (value) {
      i += 1;
      var divider = lines[i % 2].length === 0 ? '' : '|';
      lines[i % 2] += "".concat(divider).concat(value.labelText);
      value.serialNumbers.forEach(function (serial) {
        var temp = "".concat(lines[i % 2], ";").concat(serial);
        if (temp.length <= 35) {
          lines[i % 2] = temp;
        }
      });
    });
    setLabelRefText(lines);
  }, [selectedContents, isRush]);
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return axios.get(shippingEndpoint);
            case 1:
              response = _context.v;
              setData(response.data);
              setLoading(false);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              setError(_t);
              setLoading(false);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();
    fetchData();
  }, []);
  var hazmatHtml = '<h3>Mailing instructions</h3>\n' + '            <ul>\n' + '              <li>Be sure Lithium-ion Batteries are locked in battery drawer of hearing device.</li>\n' + '              <li>Never return loose Lithium-ion Batteries back to SBOHearingUS for any reason.</li>\n' + '              <li>Affix Non-Restricted Lithium-ion Battery labels to the shipping label.</li>\n' + '              <li>Labels should not touch or be folded over the side of the box.</li>\n' + '            </ul>';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, "Package and service information"), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(SboAddressInfo, {
    addressInfo: data,
    error: error,
    isLoading: loading
  }), /*#__PURE__*/React.createElement(SboPackageContent, {
    contentTypes: contentTypes,
    setSelectedContentTypes: setSelectedContents,
    handleValidationChange: function handleValidationChange(v) {
      return _handleValidationChange(v);
    },
    showErrors: showErrors
  }), /*#__PURE__*/React.createElement(SboPackageOptions, {
    setIsRush: setIsRush,
    handleIsLion: setHasLithium,
    handleValidationChange: function handleValidationChange(v) {
      return _handleValidationChange(v);
    },
    showErrors: showErrors
  }), /*#__PURE__*/React.createElement("button", {
    className: "button dark-bg no-top-margin",
    onClick: function onClick(e) {
      e.preventDefault();
      setShowErrors(false);
      if (validations.size !== 0) {
        setShowErrors(true);
        return;
      }
      setShowPrintShippingLabelModal(true);
    },
    type: "button"
  }, "Print Label"), hasLithium && /*#__PURE__*/React.createElement("button", {
    className: "button dark-bg no-top-margin",
    onClick: function onClick(e) {
      e.preventDefault();
      setShowPrintHazardLabelModal(true);
    },
    type: "button"
  }, "Print Lithium-ion Label"), /*#__PURE__*/React.createElement("div", {
    className: "label-limitation"
  }, "Note: We are unable to process labels for Puerto Rico due to UPS set-up limitations. Please call us at 1-800-327-3394 for assistance.")), /*#__PURE__*/React.createElement(SboPrintModalDialog, {
    isOpen: showPrintShippingLabelModal,
    onOkClick: function onOkClick() {
      return setShowPrintShippingLabelModal(false);
    },
    onCancelClick: function onCancelClick() {
      return setShowPrintShippingLabelModal(false);
    },
    onRequestClose: function onRequestClose() {
      return setShowPrintShippingLabelModal(false);
    },
    type: SboPrintModalDialog.types.printDownload,
    defaultFilename: "Shipping Label",
    showCloseButton: true
  }, /*#__PURE__*/React.createElement(SboPrintShippingLabel, {
    referenceLine1: (_labelRefText$ = labelRefText[0]) !== null && _labelRefText$ !== void 0 ? _labelRefText$ : '',
    referenceLine2: (_labelRefText$2 = labelRefText[1]) !== null && _labelRefText$2 !== void 0 ? _labelRefText$2 : '',
    instructionsHTML: '',
    config: config.config
  })), /*#__PURE__*/React.createElement(SboPrintModalDialog, {
    isOpen: showPrintHazardLabelModal,
    onOkClick: function onOkClick() {
      return setShowPrintHazardLabelModal(false);
    },
    onCancelClick: function onCancelClick() {
      return setShowPrintHazardLabelModal(false);
    },
    onRequestClose: function onRequestClose() {
      return setShowPrintHazardLabelModal(false);
    },
    type: SboPrintModalDialog.types.printDownload,
    defaultFilename: "Lithium-ion Label",
    showCloseButton: true
  }, /*#__PURE__*/React.createElement(SboPrintHazMatLabel, {
    instructionsHTML: hazmatHtml
  })));
};
new WDHSboPrintShippingLabelSpot().run();